/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 14/01/2014
 * Time: 13:53
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').factory('VatView', ["$filter", "Vat", "VatData", "VatSrv",
    function ($filter, Vat, VatData, VatSrv) {

        var VatView = function (vat, vIndex) {
            this.vIndex = vIndex;
            this.code = null;
            this.tax = null;
            this.taxInput = "";
            this.isDefault = null;
            this.isUsable = null;
            this.loadDataFrom(vat);
        };
        VatView.prototype.getModel = function () {
            if (this.vIndex != -1)
                return VatData.getByIndex(this.vIndex);
            return null;
        }
        VatView.prototype.loadDataFrom = function (vat) {
            if (vat !== undefined && vat) {
                this.code = vat.code;
                this.tax = vat.tax;
                this.taxInput = $filter('number')(this.tax, 2);
                this.isDefault = vat.isDefault;
                this.isUsable = vat.isUsable;
            }
        }
        VatView.prototype.copyDataTo = function (vat)//
        {
            vat.code = this.code;
            vat.tax = this.tax;
            vat.isDefault = this.isDefault;
            vat.isUsable = this.isUsable;
        }

        VatView.prototype.isChanged = function () {
            var vat = this.getModel();
            if (vat)
                return (
                    this.code != vat.code ||
                    this.tax != vat.tax ||
                    this.isDefault != vat.isDefault ||
                    this.isUsable != vat.isUsable
                );
            else
                return true;

        };
        VatView.prototype.onTaxInputChange = function () {
            if (this.taxInput != null && typeof this.taxInput === 'string') {
                var taxStr = this.taxInput.replace(",", ".").replace(" ", "");
                var tax = parseFloat(taxStr);
                if (tax !== "NaN")
                    this.tax = tax;
                else
                    this.tax = null;

            }
        }
        VatView.prototype.removeModel = function () {
            var vat = this.getModel();
            if (vat != null)
                VatSrv.remove(vat);
        }
        VatView.prototype.reloadModel = function () {
            var vat = this.getModel();
            if (vat != null)
                this.loadDataFrom(vat);

        }
        VatView.prototype.updateModel = function (save, endFunction) {
            //Save by default
            var vat = this.getModel();
            if (!vat)//create it
            {
                vat = new Vat();
                this.vIndex = VatData.getIndexOf(vat);
            }

            this.copyDataTo(vat);
            if (save === undefined || save)//Save by default
                VatSrv.save(vat, endFunction);
        }
        VatView.prototype.restoreModel = function () {
            var vat = this.getModel();
            if (vat)
                VatSrv.restore(vat);
        }
        VatView.prototype.canSave = function () {
            return true;
        }


        return VatView;
    }]);




// WEBPACK FOOTER //
// ./js/services/views/VatView.js